import Cache from '@fs/zion-cache'
import CacheService from '@fs/zion-cache-service'

const tenSecondLifeTime = 10000

export const cache = new Cache({
  storeName: 'groupManagementAppServices',
  type: 'memory',
  lifetime: tenSecondLifeTime,
})

export const cacheService = new CacheService({
  cache,
  strategy: 'cache-first',
})

// Legacy aliases for backward compatibility
export const cacheOld = cache
export const cacheServiceOld = cacheService
